module.exports = __webpack_public_path__ + "static/apple-icon-120x120-e9dd43556b07ce47599f20f45d8be6bc.png";